import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {teamGroupToLabel} from '@/features/projects/utils'
import {useTranslation, TKey} from '@/translations/i18n'
import {useController, useFormContext} from 'react-hook-form'
import {z} from 'zod'
import {useMemo} from 'react'
import {TeamGroup} from '@/features/treatment-requests/teams/types'

interface EditProjectTeamGroupFieldProps {
    index: number
    isAReserve?: boolean
}

const EditProjectTeamGroupFieldSchema = ProjectFieldsSchema.pick({
    team: true
})
type EditProjectTeamGroupFieldSchema = z.infer<typeof EditProjectTeamGroupFieldSchema>

export const EditProjectTeamGroupField = ({isAReserve, index}: EditProjectTeamGroupFieldProps) => {
    const {t} = useTranslation()
    const {control} = useFormContext<EditProjectTeamGroupFieldSchema>()
    const {field} = useController({
        control,
        name: `team.${index}`
    })

    // Create a filtered version of the options that excludes referring_doctor when isAReserve is true
    const filteredOptions = useMemo(() => {
        if (!isAReserve) {
            return teamGroupToLabel
        }

        // Filter out referring_doctor from options
        return Object.fromEntries(
            Object.entries(teamGroupToLabel).filter(([key]) => key !== 'referring_doctor')
        ) as Record<TeamGroup, TKey>
    }, [isAReserve])

    const handleChangeSpecializationGroup = (value: TeamGroup) => {
        field.onChange({
            id: null,
            fullName: null,
            specializationName: null,
            group: value
        })
    }

    return (
        <InputSelect
            label={t('projects:group')}
            placeholder={t('projects:select_group')}
            optionsMap={filteredOptions}
            value={field.value.group}
            onChange={handleChangeSpecializationGroup}
        />
    )
}
